import { BaseDto } from './base.dto';
import { BrandDto } from './brand.dto';
import { MenuHoursDto } from './menuHours.dto';
import { MenuMenuCategoryDto } from './menuMenuCategory.dto';
import { MerchantDto } from './merchant.dto';
import { PriceBracketDto } from './priceBracket.dto';
import { SaleMediumDto } from './saleMedium.dto';
import { RetailPriceDto } from './retailPrice.dto';

export class MenuDto extends BaseDto {
  guid?: string;
  merchantId: number;
  name: string;
  startDate: Date;
  endDate?: Date;
  menuHours?: MenuHoursDto[];
  saleMedium: SaleMediumDto;
  priceBracketId?: number;
  priceBracket?: PriceBracketDto;
  isKiosk?: boolean = false;
  isPOS?: boolean = false;
  isParked?: boolean = false;
  isOrderAtTable?: boolean = false;
  isDeliveryPartner?: boolean = false;
  isUltraOrder?: boolean = false;
  isWebOrdering?: boolean = false;
  isMobile?: boolean = false;
  isCatering?: boolean = false;
  posProductLookup?: boolean;
  isUrlAccessible?: boolean;
  active?: boolean;
  brandId?: number;
  brand?: BrandDto;
  online?: boolean;
  merchant?: MerchantDto; // UP-3118 - Allow for join response
  sharedSourceName?: string;
  menuMenuCategories?: MenuMenuCategoryDto[];
  isDefaultPOSMenu?: boolean;
  tag: string;
  sequence?: number;
  retailPrice: RetailPriceDto;
}
